import i18n from "i18n";
import UserNotification from "util/UserNotification";
export const handleFailures = (failures = [], actionPastTense = "submitted") => {
  if (failures.length) {
    UserNotification.error(
      i18n.t("notifications.failures_error", {
        ns: "enterprise_data_lake",
        action: i18n.t(`notifications.past_tense.${actionPastTense}`, {
          ns: "enterprise_data_lake",
          defaultValue: actionPastTense
        })
      })
    );
  } else {
    UserNotification.success(
      i18n.t("notifications.failures_success", {
        ns: "enterprise_data_lake",
        action: i18n.t(`notifications.past_tense.${actionPastTense}`, {
          ns: "enterprise_data_lake",
          defaultValue: actionPastTense
        })
      }),
      i18n.t("notifications.success_title", { ns: "enterprise_data_lake" })
    );
  }
};
